import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, useRouteMatch } from 'react-router-dom';
import { currentRouteAction, setThirdLevelRouteAction } from '../../../../../main/action';
import { IHasPageChangeRef } from '../../../../../main/interface/has-page-change';
import PermissionsView from './permissions';

interface IPermissionsProps {
  hasPageChangeRef: React.MutableRefObject<IHasPageChangeRef>;
}

class PermissionsModule {

  name = 'permissions';

  render: React.FC<IPermissionsProps> = (props) => {

    const dispatch = useDispatch();
    const match = useRouteMatch();

    useEffect(() => {
      dispatch(setThirdLevelRouteAction({
        mainRoute: 'portal',
        subRoute: 'business-processes',
        thirdLevelRoute: this.name
      }))
      dispatch(currentRouteAction(this.name))
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
      <Route path={`${match.path}`}>
        <div className='permissions-view-main-container bp-portal-submenu'>
          <PermissionsView {...props} />
        </div>
      </Route>
    );
  }
}

export default PermissionsModule;